// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"z2-z","displaySixCardTiles":"A2-z"};